<dialog part="dialog">
  {#if not closeable}
    <ui-icon link x class="close"></ui-icon>
  {/if}
  <div class="{uiClasses}modal" part="modal">
    {>slot}
  </div>
</dialog>
